const toNumber = (val: any) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    loggable: {
      name: 'รายละเอียด',
      width: '1fr',
      class: 'text-left',
      filter: (val: any, row: any) => `${row.item.loggable.description}`,
    },
    amount: {
      name: 'จำนวน',
      width: '6rem',
      class: 'text-right',
      filter: (val: any, row: any) => `${toNumber(row.item.loggable?.filled_amount)} ${row.item.loggable?.unit}`,
    },
  },

  sortable: [
    'type',
    'code',
    'updated_at',
  ],
};
